import { onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { emitter } from 'shared/helpers/mitt';
import { BUS_EVENTS } from 'shared/constants/busEvents';
import { useAlert } from 'dashboard/composables';
import { isAInboxViewRoute } from 'dashboard/helper/routeHelpers';

// Notification toasts carry a link, so they need to outlive the default 2.5s
// pill long enough to be read and clicked.
const NOTIFICATION_TOAST_DURATION = 5000;

/**
 * Shows a toast whenever a realtime notification arrives, so agents notice
 * mentions, assignments and SLA misses without watching the bell badge.
 */
export function useNotificationToast() {
  const route = useRoute();
  const { t } = useI18n();

  const showNotificationToast = ({ notification }) => {
    // The notification centre already renders the new row in place; a toast on
    // top of it would only repeat what the agent is looking at.
    if (isAInboxViewRoute(route.name, true)) return;

    const conversationId = notification.primary_actor?.id;

    useAlert(notification.push_message_title || t('INBOX.TOAST.TITLE'), {
      type: 'link',
      to: conversationId
        ? {
            name: 'inbox_view_conversation',
            params: { type: 'conversation', id: conversationId },
          }
        : { name: 'inbox_view' },
      message: t('INBOX.TOAST.VIEW'),
      duration: NOTIFICATION_TOAST_DURATION,
    });
  };

  onMounted(() => {
    emitter.on(BUS_EVENTS.NOTIFICATION_RECEIVED, showNotificationToast);
  });

  onUnmounted(() => {
    emitter.off(BUS_EVENTS.NOTIFICATION_RECEIVED, showNotificationToast);
  });
}
